export const ReporteSalidaMPLang = {

  es: {
    titulo: "SALIDA DE MATERIA PRIMA",
    noRequisa: "No. Requisa Materia Prima:",
    noIngreso: "No. Ingreso:",
    area: "Área:",
    personaSolicita: "Persona Solicita:",

    estado: "Estado",
    fecha: "Fecha",
    producto: "Producto",
    ginBale: "Gin Bale",
    correlativo: "No. Pacas",
    grado: "Grado",
    cantidadPacas: "Cantidad Pacas",
    pesoNeto: "Peso Neto Kg",
    pesoNetoLbs: "Peso Neto Lbs",

    comentario: "Comentario:",
    totalPacas: "Total Pacas:",
    totalPesoNeto: "Total Peso Neto:",
    totalPesoNetoLbs: "Total en Libras:",

    despacho: "Despachó",
    recibio: "Recibió",
    autorizo: "Autorizó",

    fechaImpresion: "Fecha de impresión:",
    pagina: "Página",
  },

  en: {
    titulo: "RAW MATERIAL DISPATCH",
    noRequisa: "Raw Material Requisition No.:",
    noIngreso: "Entry No.:",
    area: "Area:",
    personaSolicita: "Requested By:",

    estado: "Status",
    fecha: "Date",
    producto: "Product",
    ginBale: "Gin Bale",
    correlativo: "Bale No.",
    grado: "Grade",
    cantidadPacas: "Bale Quantity",
    pesoNeto: "Net Weight Kg",
    pesoNetoLbs: "Net Weight Lbs",

    comentario: "Comment:",
    totalPacas: "Total Bales:",
    totalPesoNeto: "Total Net Weight:",
    totalPesoNetoLbs: "Total in Pounds:",

    despacho: "Dispatched By",
    recibio: "Received By",
    autorizo: "Authorized By",

    fechaImpresion: "Print date:",
    pagina: "Page",
  },

};